module.exports = __webpack_public_path__ + "static/img/hr-icon-1.b9339d55.svg";